import { cloneElement } from 'react';
import { twMerge } from 'tailwind-merge';
import { useBackToTop } from 'minimal-shared/hooks';

import { Button } from '../ui';
import { Iconify } from '../iconify';

type BackToTopProps = {
  className?: string;
  isDebounce?: boolean;
  scrollThreshold?: string | number;
  renderButton?: (isVisible?: boolean) => React.ReactElement;
};

export function BackToTopButton({
  className = '',
  isDebounce,
  renderButton,
  scrollThreshold = '40%',
  ...other
}: BackToTopProps) {
  const { onBackToTop, isVisible } = useBackToTop(scrollThreshold, isDebounce);

  if (renderButton) {
    return cloneElement(renderButton(isVisible) as React.ReactElement<{ onClick?: () => void }>, {
      onClick: onBackToTop,
    });
  }

  return (
    <Button
      aria-label="Back to top"
      onClick={onBackToTop}
      variant="contained"
      color="primary"
      className={twMerge(
        'w-12 h-12 fixed rounded-full',
        'right-6 bottom-6 md:right-8 md:bottom-8 z-50',
        'transition-transform duration-300 ease-in-out p-0',
        isVisible ? 'scale-100' : 'scale-0',
        className
      )}
      {...other}
    >
      <Iconify width={24} icon="lucide:chevron-up" className="mx-auto" />
    </Button>
  );
}
